export const AE_SET_LOADING = "AE_SET_LOADING";
export const AE_SET_ERROR = "AE_SET_ERROR";

export const AE_SET_ADMIN_EMPLOYERS = "AE_SET_ADMIN_EMPLOYERS";
export const AE_ADD_ADMIN_EMPLOYER = "AE_ADD_ADMIN_EMPLOYER";
export const AE_UPDATE_ADMIN_EMPLOYER = "AE_UPDATE_ADMIN_EMPLOYER";
export const AE_REMOVE_ADMIN_EMPLOYER = "AE_REMOVE_ADMIN_EMPLOYER";

export const AE_SET_BOARD_EMPLOYERS = "AE_SET_BOARD_EMPLOYERS";
export const AE_ADD_BOARD_EMPLOYER = "AE_ADD_BOARD_EMPLOYER";
export const AE_REMOVE_BOARD_EMPLOYER = "AE_REMOVE_BOARD_EMPLOYER";
export const AE_SET_AVAILABLE_EMPLOYERS = "AE_SET_AVAILABLE_EMPLOYERS";

export const AE_SET_EXECUTIONS = "AE_SET_EXECUTIONS";
export const AE_ADD_EXECUTION = "AE_ADD_EXECUTION";
export const AE_UPDATE_EXECUTION = "AE_UPDATE_EXECUTION";

export const AE_SET_QUESTIONS = "AE_SET_QUESTIONS";
export const AE_ADD_QUESTION = "AE_ADD_QUESTION";
export const AE_UPDATE_QUESTION = "AE_UPDATE_QUESTION";
export const AE_REMOVE_QUESTION = "AE_REMOVE_QUESTION";
export const AE_SET_BOARD_PENDING_QUESTIONS = "AE_SET_BOARD_PENDING_QUESTIONS";

export const AE_RESET = "AE_RESET";
